<template>
    <div class="login-wrap">
        <div class="input">
            <div class="label">
              <span class="text">{{$t('login.email')}}</span>
            </div>
            <div class="item">
                <input type="text"
                 v-model.trim="email"
                 @focus="emailError = false"
                 :placeholder="$t('login.emailPlaceholder')"
                 :class="{error: emailError}"
                 @keypress.enter="login"
                >
            </div>
            <small v-if="emailError">{{$t('login.emailError')}}</small>
        </div>
        <div class="input">
            <div class="label">
              <span class="text">{{$t('login.password')}}</span>
              <span class="forgot">{{$t('login.forgotPassword')}} <router-link tabindex = "-1" to="/forgotpassword">{{$t('login.resetHere')}}</router-link></span>
            </div>
            <div class="item">
                <input :type="visible ? 'text' : 'password'"
                 :class="{error: passwordError}" v-model="password"
                 @focus="passwordError = false"
                 :placeholder="$t('login.passwordPlaceholder')"
                 @keypress.enter="login"
                >
                <div class="reveal-password" @click="handlePassword(!visible)">
                    <span class="material-icons">
                        {{visible ? 'visibility_off' : 'visibility'}}
                    </span>
                </div>
            </div>
            <small v-if="passwordError">{{$t('login.passwordError')}}</small>
        </div>
        <div class="button-wrap">
            <div class="no-acc-text">{{$t('login.dontHaveAcc')}} <router-link to="/register">{{$t('login.createOneHere')}}</router-link></div>
            <div class="button-round" @click="login">{{$t('button.login')}} &nbsp;<span class="material-icons">arrow_right_alt</span></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            email: '',
            password: '',
            visible: false,
            emailError: false,
            passwordError: false
        }
    },
    methods: {
        login () {
            const emailCheck = /^(\w+.?)+@(\w+.?)+.\w+$/.test(this.email)
            const passwordCheck = this.password.length >= 3
            if (!emailCheck) {
                this.emailError = true
            }
            if (!passwordCheck) {
                this.passwordError = true
            }
            if (!emailCheck || !passwordCheck) {
                return
            }
            this.$emit('login', { email:this.email, password: this.password })
        },
        handlePassword (val) {
            this.visible = val
        }
    }
}
</script>

<style scoped lang="scss">
.forgot-password {
    &:hover {
        text-decoration: underline;
    }
    position: relative;
    text-align: right;
    font-size: 14px;
    font-style: italic;
    cursor: pointer;
    color: #348fef;
}
.button-wrap {
    margin: 30px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.button-round {
    background: var(--button-color-yellow);
}
.item {
        position: relative
    }
.input {
    margin: 15px 0;
    span {
        margin-bottom: 3px;
    }
    small {
        color: red;
    }
    input {
        transition: border-color .2s ease;
        &.error {
            border-color: red;
        }
    }
}
.reveal-password {
    position: absolute;
    display: inline;
    top: 55%;
    transform: translateY(-50%);
    right: 6px;
    cursor: pointer;
    user-select: none;
    opacity: .5;
}
.label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5vw;
  .forgot {
    font-size: 0.9em;
    font-weight: 200;
  }
  .text {
    margin-left: 15px;
  }
}
.no-acc-text {
  font-size: 0.9em;
  font-weight: 200;
  margin-right: 10px;
}
a {
  color: #F2BD00;
}
</style>